import axios from 'axios';
import qs from 'qs';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.transformRequest = [function (data, headers) {
  return qs.stringify(data);
}];
axios.interceptors.response.use(function (_ref) {
  var data = _ref.data;

  if (typeof data.code !== 'undefined') {
    // 兼容后端接口中的code字段
    if (data.code === 'SUCCESS') {
      data.result = 1;
    } else {
      data.result = data.code;
    }

    delete data.code;
  }

  if (typeof data.msg !== 'undefined') {
    // 兼容后端接口中的msg字段
    data.error_msg = data.msg;
    delete data.msg;
  }

  return data;
}, function (error) {
  if (error.response && error.response.status === 401) {
    return {
      result: 401,
      error_msg: '获取身份信息失败'
    };
  }

  var net_error = '网络错误，请重试';
  return {
    isNetworkError: true,
    result: error.response && error.response.status || 999,
    error_msg: error.error_msg || net_error
  };
});
export default axios;